import { MatDialogConfig } from '@angular/material/dialog';

export const stageFinMonErrorCodes = {
  NoBirthDate: '200002655142',
  InaccessibleFinancialServices: '200002655141',
};

export const prodFinMonErrorCodes = {
  NoBirthDate: '20000204114',
  InaccessibleFinancialServices: '20000204115',
};

export const financialMonitoringModalConfig: MatDialogConfig = {
  panelClass: 'no-padding',
  width: '650px',
  autoFocus: false,
  restoreFocus: false,
}
